import { RegisterEmployabilityCharterRequest } from '@/domain/entities/procedures/RegisterEmployabilityCharterRequest';
import ProceduresDataStore from '../../datastores/ProceduresDataStore';

export default class ProceduresDataStoreMock implements ProceduresDataStore {
  registerEmployabilityCharter(request: RegisterEmployabilityCharterRequest) {
    return {
      requestId: '1601',
      error: `${request}`
    };
  }

  getModalityOptionList() {
    return [
      {
        id: 'PSI50',
        name: 'Cambiar a Ingeniería De Sistemas E Informática - Modalidad Semipresencial – 50% Virtual. Los créditos aprobados en modalidad virtual, a lo largo de la carrera, son 50%. Los cursos tienen una duración de 18 semanas.',
        tag: '',
        grado: 'A',
        plan: 'B',
        turns: [
          {
            id: '1',
            name: 'Nocturno'
          },
          {
            id: '2',
            name: 'Fin de semana'
          }
        ]
      },
      {
        id: 'PSI80',
        name: 'Cambiar a Ingeniería De Sistemas E Informática - Modalidad A Distancia – 80% Virtual. Los créditos aprobados en modalidad virtual, a lo largo de la carrera, son 80%. Los cursos tienen una duración de 18 semanas.',
        tag: '',
        grado: 'A',
        plan: 'B',
        turns: [
          {
            id: '3',
            name: 'Nocturno día de semana'
          },
          {
            id: '2',
            name: 'Fin de semana'
          }
        ]
      },
      {
        id: 'PSISV',
        name: 'Cambiar a Ingeniería De Sistemas E Informática - Modalidad A Distancia – 100% Virtual. Los créditos aprobados en modalidad virtual, a lo largo de la carrera, son 100%. Los cursos tienen una duración de 18 semanas. Para esta modalidad se requiere tener 24 o más años al momento de iniciar el ciclo académico.',
        tag: '',
        plan: 'B',
        turns: [
          {
            id: '3',
            name: 'Nocturno día de semana'
          },
          {
            id: '2',
            name: 'Fin de semana'
          }
        ]
      }
    ];
  }

  async activateRegisterCarnet() {
    const data = {
      activateRegisterCarnet: {
        error: '',
        requestId: 16
      }
    };
    return data;
  }

  async cancelRegisterCarnet() {
    const data = {
      cancelRegisterCarnetRequestProcedure: {
        error: '',
        requestId: 16
      }
    };
    return data;
  }

  async registerCarnet() {
    const response = {
      data: {
        requestId: '16',
        error: ''
      }
    };

    return response.data;
  }

  async getProceduresByStudent() {
    const data = [
      {
        id: 1601,
        procedureId: 1038,
        name: 'Carta de empleabilidad 1',
        status: {
          status: 'NO_PROCEDE',
          name: 'No procede',
          description: 'No procede'
        },
        durationEnd: '',
        duration: 'Inmediato',
        dateEnd: '30 Nov 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 1007,
        procedureId: 1017,
        name: 'Rectificación de nota',
        status: {
          status: 'NO_PROCEDE',
          name: 'No registrado',
          description: 'No registrado'
        },
        durationEnd: '',
        duration: 'Inmediato',
        dateEnd: '30 Nov 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 5005,
        procedureId: 1036,
        name: 'Retiro de Cursos',
        status: {
          status: 'PROCEDE',
          name: 'Procede',
          description: 'Procede'
        },
        // status: 'PAGO ACTIVADO',
        // status: 'PAGO REALIZADO',
        // status: 'FINALIZADO',
        durationEnd: '',
        duration: 'Inmediato',
        dateEnd: '30 Nov 2021',
        lastUpdated: '25 Feb 2022'
        // type: 'TICKET'
      },
      {
        id: 1000,
        procedureId: 1018,
        name: 'Constancia de estudios',
        status: {
          status: 'CREADO',
          name: 'Finalizado',
          description: 'Procede'
        },
        // status: 'PAGO ACTIVADO',
        // status: 'PAGO REALIZADO',
        // status: 'FINALIZADO',
        durationEnd: '',
        duration: 'Inmediato',
        dateEnd: '01 Feb 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 10,
        procedureId: 1026,
        name: 'Cambio de carrera, campus o modalidad',
        status: {
          status: 'CREADO',
          name: 'Pendiente',
          description: 'Activar pago'
        },
        duration: '7 días hábiles',
        dateEnd: '25 Feb 2022',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 11,
        procedureId: 1026,
        name: 'Cambio de carrera, campus o modalidad',
        status: {
          status: 'PAGO_ACTIVADO',
          name: 'Pendiente',
          description: 'Por pagar'
        },
        duration: '7 días hábiles',
        dateEnd: '25 Feb 2022',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 12,
        procedureId: 1026,
        name: 'Cambio de carrera, campus o modalidad',
        status: {
          status: 'PAGO_REALIZADO',
          name: 'Pendiente',
          description: 'Por atender en UTP'
        },
        duration: '7 días hábiles',
        dateEnd: '25 Feb 2022',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 13,
        procedureId: 1026,
        name: 'Cambio de carrera, campus o modalidad',
        status: {
          status: 'PROCEDE',
          name: 'Finalizado',
          description: 'Procede'
        },
        duration: '7 días hábiles',
        dateEnd: '25 Feb 2022',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 14,
        procedureId: 1026,
        name: 'Cambio de carrera, campus o modalidad',
        status: {
          status: 'NO_PROCEDE',
          name: 'Finalizado',
          description: 'No procede'
        },
        duration: '7 días hábiles',
        dateEnd: '25 Feb 2022',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 1001,
        procedureId: 1018,
        name: 'Constancia de estudios',
        status: {
          status: 'PAGO_ACTIVADO',
          name: 'Pendiente',
          description: 'Por pagar'
        },
        // status: 'PAGO ACTIVADO',
        // status: 'PAGO REALIZADO',
        // status: 'FINALIZADO',
        durationEnd: '',
        duration: 'Inmediato',
        dateEnd: '01 Feb 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 2001,
        procedureId: 1021,
        name: 'Retiro de Periodo Lectivo',
        status: {
          status: 'PENDIENTE',
          name: 'Pendiente',
          description: 'Por atender en UTP'
        },
        duration: '7 días hábiles',
        dateEnd: '25 Oct 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 2002,
        procedureId: 1021,
        name: 'Retiro de Periodo Lectivo',
        status: {
          status: 'PROCEDE',
          name: 'Finalizado',
          description: 'Procede'
        },
        duration: '10 dias',
        dateEnd: '25 Oct 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 2003,
        procedureId: 1021,
        name: 'Retiro de Periodo Lectivo',
        status: {
          status: 'NO_PROCEDE',
          name: 'Finalizado',
          description: 'No procede'
        },
        duration: '10 dias',
        dateEnd: '25 Oct 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 3001,
        procedureId: 1019,
        name: 'Constancia de ingreso',
        status: {
          status: 'CREADO',
          name: 'Pendiente',
          description: 'Activar pago'
        },
        duration: 'Inmediato',
        dateEnd: '01 Feb 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 3002,
        procedureId: 1019,
        name: 'Constancia de ingreso',
        status: {
          status: 'PAGO_ACTIVADO',
          name: 'Pendiente',
          description: 'Por pagar'
        },
        duration: 'Inmediato',
        dateEnd: '01 Feb 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 3003,
        procedureId: 1019,
        name: 'Constancia de ingreso',
        status: {
          status: 'FINALIZADO',
          name: 'Finalizado',
          description: 'Procede'
        },
        duration: 'Inmediato',
        dateEnd: '18 Nov 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 3003,
        procedureId: 1023,
        name: 'Constancia de Promedio Ponderado',
        status: {
          status: 'FINALIZADO',
          name: 'Finalizado',
          description: 'Procede'
        },
        duration: 'Inmediato',
        dateEnd: '18 Nov 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 15,
        procedureId: 1027,
        name: 'Constancia de adeudo / no adeudo',
        status: {
          status: 'FINALIZADO',
          name: 'Finalizado',
          description: 'Procede'
        },
        duration: 'Inmediato',
        dateEnd: '18 Nov 2021',
        lastUpdated: '25 Feb 2022'
      },
      {
        id: 124787,
        procedureId: 1031,
        name: 'Cambio de opción de estudio - Modalidad',
        status: {
          status: 'PROCEDE',
          name: 'Finalizado',
          description: 'Procede'
        },
        duration: 'Inmediato',
        lastUpdated: '03 Feb 2023'
      }
    ];
    return data;
  }

  // {
  //   id: 1,
  //   name: 'Subir foto',
  //   order: 1,
  //   isComplete: true,
  //   isCurrent: true,
  //   date: '05 Abr 2023'
  // },
  // {
  //   id: 2,
  //   name: 'Estado de solicitud',
  //   order: 2,
  //   isComplete: false,
  //   isCurrent: false,
  //   date: ''
  // }

  async getProcedureInformation(procedureId: number) {
    if (procedureId === 1036) {
      return {
        id: 1036,
        amount: '117',
        duration: 'Inmediato',
        name: 'Retiro de Curso',
        steps: [
          {
            id: 33,
            name: 'Registrar solicitud',
            order: 1
          },
          {
            id: 34,
            name: 'Realizar pago',
            order: 2
          },
          {
            id: 35,
            name: 'Estado de solicitud',
            order: 3
          }
        ],
        model: null,
        requirements: null,
        pin1: null,
        pin2: null,
        moreInfo: null,
        currentRequestId: 0,
        isValidatedStudentFoto: null,
        requestInProgress: false,
        disabled: false,
        endDate: '30 Jun 2024',
        text1: null,
        enrollment: true,
        requestLimit: null,
        enrolledCourses: null,
        stepsToFollow: null,
        deliverySchedule: null,
        hasPhoto: null,
        isProvince: null,
        isEntering: null,
        isReincorporated: null,
        isprocessFinished: null,
        isEnrolledInCoursesM1: false,
        districts: null,
        reasons: null,
        periods: null,
        error: null,
        detail: {
          enrolledCourses: [
            {
              id: '100000U18F',
              name: 'ANALISIS DE LA INFORMACION FINANCIERA(M2)',
              classId: '41654',
              courseId: '014584'
            },
            {
              id: '100000U24F',
              name: 'TALLER DE NIIF(M2)',
              classId: '41681',
              courseId: '014601'
            }
          ],
          hasScholarship: false,
          datesModule: [
            {
              name: 'Módulo 1',
              deadlineWithRecalc: '2023-08-26T00:00:00',
              deadlineWithoutRecalc: '2024-05-17T00:00:00'
            },
            {
              name: 'Módulo 2',
              deadlineWithRecalc: '2023-10-28T00:00:00',
              deadlineWithoutRecalc: '2024-07-19T00:00:00'
            },
            {
              name: 'BiModular',
              deadlineWithRecalc: '2023-10-28T00:00:00',
              deadlineWithoutRecalc: '2024-07-19T00:00:00'
            }
          ],
          relatedCourses: [],
          periodApplied: [
            {
              id: '2242',
              name: '2024 - Ciclo 1 Marzo'
            }
          ],
          studiesOptionList: null,
          campusApplied: null,
          applySince: null,
          periodId: null,
          periodDesc: null,
          program: null,
          weightedAverage: null,
          hasDebts: null,
          modalityList: null,
          currentAcademicData: {
            program: {
              id: null,
              name: null
            },
            campus: {
              id: null,
              name: null
            },
            modality: {
              id: null,
              name: null
            },
            grouping: {
              id: null,
              name: null
            },
            studiesOption: {
              careerName: null,
              modalityName: null,
              careerCode: null,
              modalityCode: null
            }
          }
        }
      };
    }
    if (procedureId === 1020) {
      return {
        id: 1020,
        amount: 'Sin costo',
        duration: 'Inmediato',
        name: 'Registro / Actualización de Fotografía',
        steps: [
          {
            date: '',
            id: 1,
            isComplete: true,
            isCurrent: true,
            name: 'Registrar solicitud',
            order: 1
          },
          {
            date: '',
            id: 2,
            isComplete: false,
            isCurrent: false,
            name: 'Estado de solicitud',
            order: 2
          }
        ],
        requirements: [
          'Tamaño carné, a color y fondo blanco sin sombras.',
          'De frente, tipo fotografía para DNI (no se aceptan selfies).',
          'El nombre del archivo debe ser tu código de alumno.',
          'Sin lentes, ni gorras, ni estar vestido completamente de blanco.',
          'Peso del archivo debe ser de 30 a 50 kb resolución de 300 dpi como mínimo (no pixeleadas ni con ruido digital).',
          'Vestimenta formal:'
        ],
        text1: 'Mujer: blusa y sastre.|Varón: camisa, corbata y saco.',
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 0,
        requestInProgress: false
      };
    }
    if (procedureId === 1021) {
      return {
        id: 1021,
        amount: 'Sin costo',
        duration: '7 dias',
        name: 'Retiro de Periodo Lectivo',
        steps: [
          {
            id: 1,
            name: 'Registro de solicitud',
            order: 1
          },
          {
            id: 2,
            name: 'Estado de solicitud',
            order: 2
          }
        ],
        requirements: [
          'Confirma o registra tu número de contacto.',
          'Cuéntanos el motivo y más detalles para poder orientarte.',
          'Recibe la conformidad u observaciones a tu correo una vez finalizado el trámite.'
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 2,
        text1:
          'De aplicar la solicitud de retiro de período, solo se realizará la reversión de las cuotas no vencidas.',
        requestInProgress: false,
        endDate: '25 Dic 2021',
        reasons: ['Económico', 'Laboral', 'Salud', 'Otros']
      };
    }
    if (procedureId === 1018) {
      return {
        id: 1018,
        amount: '22',
        duration: 'Inmediato',
        name: 'Constancia de estudios',
        steps: [
          {
            id: 1,
            name: 'Selecciona el ciclo',
            order: 1
          },
          {
            id: 2,
            name: 'Realiza el pago',
            order: 2
          },
          {
            id: 3,
            name: 'Descargar constancia',
            order: 3
          }
        ],
        stepsToFollow: [
          'Indica el ciclo para el cual requieres tu Constancia.',
          'Realiza el pago a través de los medios financieros autorizados.',
          'Espera para la descarga de tu Constancia.'
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 2,
        requestInProgress: false,
        modelFile: '/sample.pdf',
        periods: [
          { id: 2212, description: 'Ciclo Marzo 2021-1' },
          { id: 2211, description: 'Ciclo Verano 2021' },
          { id: 2203, description: 'Ciclo Agosto 2020-2' },
          { id: 2202, description: 'Ciclo Marzo 2020-1' },
          { id: 2201, description: 'Ciclo Verano 2020' },
          { id: 2193, description: 'Ciclo Agosto 2019-2' },
          { id: 2192, description: 'Ciclo Marzo 2019-1' }
        ],
        error: null,
        errorCiclo: {
          title: 'No tienes un ciclo concluido',
          message:
            'Para poder solicitar este trámite, mínimo tienes que tener un ciclo finalizado.'
        },
        errorDeudas: {
          title: 'Tienes deudas pendientes',
          message:
            'Puedes regularizarlas en la sección de pagos para continuar con este trámite.'
        }
      };
    }
    if (procedureId === 1019) {
      return {
        id: 1019,
        amount: 'Sin costo',
        duration: '7 dias',
        name: 'Constancia de ingreso',
        steps: [
          {
            id: 1,
            name: 'Selecciona el ciclo',
            order: 1
          },
          {
            id: 2,
            name: 'Realiza el pago',
            order: 2
          },
          {
            id: 3,
            name: 'Descargar constancia',
            order: 3
          }
        ],
        stepsToFollow: [
          'Indica el ciclo para el cual requieres tu Constancia.',
          'Realiza el pago a través de los medios financieros autorizados.',
          'Espera para la descarga de tu Constancia.'
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 2,
        requestInProgress: false,
        modelFile: '/sample.pdf',
        periods: [
          { id: 2212, description: 'Ciclo Marzo 2021-1' },
          { id: 2211, description: 'Ciclo Verano 2021' },
          { id: 2203, description: 'Ciclo Agosto 2020-2' },
          { id: 2202, description: 'Ciclo Marzo 2020-1' },
          { id: 2201, description: 'Ciclo Verano 2020' },
          { id: 2193, description: 'Ciclo Agosto 2019-2' },
          { id: 2192, description: 'Ciclo Marzo 2019-1' }
        ],
        error: null,
        errorCiclo: {
          title: 'No tienes un ciclo concluido',
          message:
            'Para poder solicitar este trámite, mínimo tienes que tener un ciclo finalizado.'
        },
        errorDeudas: {
          title: 'Tienes deudas pendientes',
          message:
            'Puedes regularizarlas en la sección de pagos para continuar con este trámite.'
        },
        admission: {
          period: 2211,
          periodDesc: 'Ciclo Marzo 2021-1',
          program: 'Ingeniería Industrial'
        }
      };
    }
    if (procedureId === 1034) {
      return {
        id: 1034,
        amount: '74',
        duration: 'Inmediato',
        name: 'Examen de Rezagados',
        steps: [
          {
            id: 24,
            name: 'Registrar solicitud',
            order: 1
          },
          {
            id: 26,
            name: 'Realizar pago',
            order: 2
          },
          {
            id: 27,
            name: 'Estado de solicitud',
            order: 3
          }
        ],
        model: null,
        requirements: null,
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        pin2: null,
        moreInfo: null,
        currentRequestId: 0,
        isValidatedStudentFoto: null,
        requestInProgress: false,
        disabled: false,
        endDate: '20 Jul 2024',
        text1: null,
        enrollment: false,
        requestLimit: null,
        enrolledCourses: [],
        stepsToFollow: null,
        deliverySchedule: null,
        hasPhoto: null,
        isProvince: null,
        isEntering: null,
        isReincorporated: null,
        isprocessFinished: null,
        isEnrolledInCoursesM1: null,
        districts: null,
        reasons: null,
        periods: null,
        error: null,
        detail: {
          enrolledCourses: null,
          hasScholarship: false,
          datesModule: null,
          relatedCourses: null,
          periodApplied: [
            {
              id: '2233',
              name: '2023 - Ciclo 2 Agosto'
            }
          ],
          studiesOptionList: null,
          campusApplied: null,
          applySince: null,
          periodId: null,
          periodDesc: null,
          program: null,
          weightedAverage: null,
          hasDebts: null,
          modalityList: null,
          currentAcademicData: {
            program: {
              id: null,
              name: null
            },
            campus: {
              id: null,
              name: null
            },
            modality: {
              id: null,
              name: null
            },
            grouping: {
              id: null,
              name: null
            },
            studiesOption: {
              careerName: null,
              modalityName: null,
              careerCode: null,
              modalityCode: null
            }
          }
        }
      };
    }
    if (procedureId === 1024) {
      return {
        id: 1024,
        amount: '22',
        duration: '7 dias',
        name: 'Constancia de Promedio Ponderado Acumulado',
        steps: [
          {
            id: 1,
            name: 'Selecciona el ciclo',
            order: 1
          },
          {
            id: 2,
            name: 'Realiza el pago',
            order: 2
          },
          {
            id: 3,
            name: 'Descargar constancia',
            order: 3
          }
        ],
        stepsToFollow: [
          'Indica el ciclo para el cual requieres tu Constancia.',
          'Realiza el pago a través de los medios financieros autorizados.',
          'Espera para la descarga de tu Constancia.'
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 2,
        requestInProgress: false,
        modelFile: '/sample.pdf',
        periods: [
          { id: 2212, description: 'Ciclo Marzo 2021-1' },
          { id: 2211, description: 'Ciclo Verano 2021' },
          { id: 2203, description: 'Ciclo Agosto 2020-2' },
          { id: 2202, description: 'Ciclo Marzo 2020-1' },
          { id: 2201, description: 'Ciclo Verano 2020' },
          { id: 2193, description: 'Ciclo Agosto 2019-2' },
          { id: 2192, description: 'Ciclo Marzo 2019-1' }
        ],
        error: null,
        errorCiclo: {
          title: 'No tienes un ciclo concluido',
          message:
            'Para poder solicitar este trámite, mínimo tienes que tener un ciclo finalizado.'
        },
        errorDeudas: {
          title: 'Tienes deudas pendientes',
          message:
            'Puedes regularizarlas en la sección de pagos para continuar con este trámite.'
        },
        admission: {
          period: 2211,
          periodDesc: 'Ciclo Marzo 2021 - Ciclo Verano 2022',
          weightedAverage: 18.6
        },
        detail: {
          period: 2211,
          periodDesc: 'Ciclo Marzo 2021 - Ciclo Verano 2022',
          weightedAverage: 18.6
        }
      };
    }
    if (procedureId === 1025) {
      return {
        id: 1025,
        amount: '22',
        duration: '7 dias',
        name: 'Constancia de Promedio Ponderado Acumulado',
        steps: [
          {
            id: 1,
            name: 'Selecciona el ciclo',
            order: 1
          },
          {
            id: 2,
            name: 'Realiza el pago',
            order: 2
          },
          {
            id: 3,
            name: 'Descargar constancia',
            order: 3
          }
        ],
        stepsToFollow: [
          'Indica el ciclo para el cual requieres tu Constancia.',
          'Realiza el pago a través de los medios financieros autorizados.',
          'Espera para la descarga de tu Constancia.'
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 2,
        requestInProgress: false,
        modelFile: '/sample.pdf',
        periods: [
          { id: 2212, description: 'Ciclo Marzo 2021-1' },
          { id: 2211, description: 'Ciclo Verano 2021' },
          { id: 2203, description: 'Ciclo Agosto 2020-2' },
          { id: 2202, description: 'Ciclo Marzo 2020-1' },
          { id: 2201, description: 'Ciclo Verano 2020' },
          { id: 2193, description: 'Ciclo Agosto 2019-2' },
          { id: 2192, description: 'Ciclo Marzo 2019-1' }
        ],
        error: null,
        errorCiclo: {
          title: 'No tienes un ciclo concluido',
          message:
            'Para poder solicitar este trámite, mínimo tienes que tener un ciclo finalizado.'
        },
        errorDeudas: {
          title: 'Tienes deudas pendientes',
          message:
            'Puedes regularizarlas en la sección de pagos para continuar con este trámite.'
        },
        admission: {
          period: 2211,
          periodDesc: 'Ciclo Marzo 2021-1',
          program: 'Ingeniería Industrial'
        },
        detail: {
          period: 2211,
          periodDesc: 'Ciclo Marzo 2021-1',
          program: 'Ingeniería Industrial'
        }
      };
    }
    if (procedureId === 1026) {
      return {
        id: 1026,
        amount: '165',
        duration: '7 días hábiles',
        name: 'Cambio de carrera, campus o modalidad',
        steps: [
          {
            id: 1,
            name: 'Registrar solicitud',
            order: 1
          },
          {
            id: 2,
            name: 'Realizar pago',
            order: 2
          },
          {
            id: 3,
            name: 'Estado de solicitud',
            order: 3
          }
        ],
        stepsToFollow: [
          'Registra tu solicitud para gestionar tu cambio de carrera, campus o modalidad. (Si te vas a cambiar de modalidad, deberás adjuntar tu constancia de egreso o de trabajo que verifique tus 3 años de experiencia laboral).',
          'Realiza el pago en nuestras opciones disponibles.',
          'Recibe la conformidad u observaciones a tu correo una vez finalizado el trámite.'
        ],
        requirements: [
          'Estar al día con las cuotas de pago.',
          'No debes estar suspendido por sanción disciplinaria.',
          'Encontrarte matriculado en el presente período académico.'
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
        link: 'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <b>utp.edu.pe/</b>',
        moreInfo:
          'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <a target="_black" href="utp.edu.pe/">utp.edu.pe/</a>',
        currentRequestId: 0,
        disabled: false,
        requestInProgress: false,
        endDate: '01 Feb 2022',
        error: null,
        detail: {
          periodId: '',
          periodDesc: '',
          program: '',
          weightedAverage: '',
          modalityList: [
            {
              id: 'PREG',
              name: 'Pre-grado'
            },
            {
              id: 'PPE',
              name: 'Programa CGT'
            }
          ],
          currentAcademicData: {
            program: {
              id: 'PCONT',
              name: 'Contabilidad'
            },
            campus: {
              id: 'LIMA',
              name: 'Campus Lima Centro'
            },
            modality: {
              id: 'PREG',
              name: 'Pre-grado'
            }
          }
        }
      };
    }
    if (procedureId === 1027) {
      return {
        id: 1027,
        amount: '22',
        duration: 'Inmediato',
        name: 'Constancia de adeudo / no adeudo',
        steps: [
          {
            id: 1,
            name: 'Registrar solicitud',
            order: 1
          },
          {
            id: 2,
            name: 'Realiza el pago',
            order: 2
          },
          {
            id: 3,
            name: 'Estado de solicitud',
            order: 3
          }
        ],
        stepsToFollow: [
          'Visualiza la información que saldrá en tu constancia antes de solicitarla.',
          'Realiza el pago en nuestras opciones disponibles.',
          'Espera para la descarga de tu Constancia.'
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 2,
        requestInProgress: true,
        modelFile: '/sample.pdf',
        periods: [
          { id: 2212, description: 'Ciclo Marzo 2021-1' },
          { id: 2211, description: 'Ciclo Verano 2021' },
          { id: 2203, description: 'Ciclo Agosto 2020-2' },
          { id: 2202, description: 'Ciclo Marzo 2020-1' },
          { id: 2201, description: 'Ciclo Verano 2020' },
          { id: 2193, description: 'Ciclo Agosto 2019-2' },
          { id: 2192, description: 'Ciclo Marzo 2019-1' }
        ],
        error: null,
        errorCiclo: {
          title: 'No tienes un ciclo concluido',
          message:
            'Para poder solicitar este trámite, mínimo tienes que tener un ciclo finalizado.'
        },
        errorDeudas: {
          title: 'Tienes deudas pendientes',
          message:
            'Puedes regularizarlas en la sección de pagos para continuar con este trámite.'
        },
        admission: {
          hasDebts: false
        }
      };
    }
    if (procedureId === 1030) {
      return {
        id: 1030,
        amount: '28',
        duration: '7 días hábiles',
        name: 'Emisión de carné universitario',
        steps: [
          {
            id: 1,
            name: 'Registrar solicitud',
            order: 1
          },
          {
            id: 2,
            name: 'Realiza el pago',
            order: 2
          },
          {
            id: 3,
            name: 'Estado de solicitud',
            order: 3
          }
        ],
        stepsToFollow: [
          'Escoge la modalidad de entrega.',
          'Realiza el pago en nuestras opciones disponibles.',
          'Recibe o recoge tu carnet.'
        ],
        hasPhoto: true,
        isProvince: false,
        districts: [
          {
            id: 1,
            name: 'lima'
          },
          {
            id: 2,
            name: 'olivos'
          },
          {
            id: 3,
            name: 'independencia'
          },
          {
            id: 4,
            name: 'surco'
          },
          {
            id: 5,
            name: 'molina'
          },
          {
            id: 6,
            name: 'lurin'
          },
          {
            id: 7,
            name: 'carabayllo'
          },
          {
            id: 8,
            name: 'comas'
          },
          {
            id: 9,
            name: 'lince'
          },
          {
            id: 10,
            name: 'barranco'
          },
          {
            id: 11,
            name: 'miraflores'
          },
          {
            id: 12,
            name: 'san martin'
          },
          {
            id: 13,
            name: 'callao'
          },
          {
            id: 14,
            name: 'san miguel'
          },
          {
            id: 15,
            name: 'chorrillos'
          },
          {
            id: 16,
            name: 'rimac'
          }
        ],
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        currentRequestId: 2,
        requestInProgress: false,
        modelFile: '/sample.pdf',
        periods: [
          { id: 2212, description: 'Ciclo Marzo 2021-1' },
          { id: 2211, description: 'Ciclo Verano 2021' },
          { id: 2203, description: 'Ciclo Agosto 2020-2' },
          { id: 2202, description: 'Ciclo Marzo 2020-1' },
          { id: 2201, description: 'Ciclo Verano 2020' },
          { id: 2193, description: 'Ciclo Agosto 2019-2' },
          { id: 2192, description: 'Ciclo Marzo 2019-1' }
        ],
        error: null,
        errorCiclo: {
          title: 'No tienes un ciclo concluido',
          message:
            'Para poder solicitar este trámite, mínimo tienes que tener un ciclo finalizado.'
        },
        errorDeudas: {
          title: 'Tienes deudas pendientes',
          message:
            'Puedes regularizarlas en la sección de pagos para continuar con este trámite.'
        },
        admission: {
          hasDebts: false
        }
      };
    }
    if (procedureId === 1031) {
      return {
        id: 1031,
        amount: 'Sin costo',
        duration: 'Inmediato',
        name: 'Cambio de opción de estudio - Modalidad',
        steps: [
          {
            id: 6,
            name: 'Registro de solicitud',
            order: 1
          },
          {
            id: 7,
            name: 'Estado de solicitud',
            order: 2
          }
        ],
        model: null,
        requirements: null,
        pin1: null,
        pin2: null,
        moreInfo: null,
        currentRequestId: 0,
        requestInProgress: true,
        disabled: false,
        endDate: '20 Dic 2023',
        text1: null,
        enrollment: false,
        requestLimit: true,
        enrolledCourses: ['Literatura 1', 'Matematica 1', 'Biologia'],
        stepsToFollow: null,
        hasPhoto: null,
        isProvince: null,
        districts: null,
        reasons: null,
        periods: null,
        isReincorporated: true,
        isEntering: true,
        error: null,
        // error: {
        //   title: 'No puedes realizar este tramite',
        //   description:
        //     'Para cambiar de modalidad debes realizar el trámite de reincorporación.'
        // },
        detail: {
          // campus: null,
          campusApplied: [
            {
              id: 'LIMAN',
              name: 'Lima Norte'
            },
            {
              id: 'LIMASJL',
              name: 'San juan de Lurigancho'
            }
            // {
            //   id: 'LIMAS',
            //   name: 'Lima Sur'
            // }
            // {
            //   id: 'LIATE',
            //   name: 'Lima Ate'
            // }
          ],
          periodApplied: [
            {
              id: '2232',
              name: '2023 - Ciclo 1 Marzo'
            },
            {
              id: '2233',
              name: '2023 - Ciclo 2 Agosto'
            }
          ],
          studiesOptionList: [
            {
              id: 'PSI50',
              name: 'Cambiar a Ingeniería De Sistemas E Informática - Modalidad Semipresencial – 50% Virtual. Los créditos aprobados en modalidad virtual, a lo largo de la carrera, son 50%. Los cursos tienen una duración de 18 semanas.',
              tag: ''
            },
            {
              id: 'PSI80',
              name: 'Cambiar a Ingeniería De Sistemas E Informática - Modalidad A Distancia – 80% Virtual. Los créditos aprobados en modalidad virtual, a lo largo de la carrera, son 80%. Los cursos tienen una duración de 18 semanas.',
              tag: ''
            },
            {
              id: 'PSISV',
              name: 'Cambiar a Ingeniería De Sistemas E Informática - Modalidad A Distancia – 100% Virtual. Los créditos aprobados en modalidad virtual, a lo largo de la carrera, son 100%. Los cursos tienen una duración de 18 semanas. Para esta modalidad se requiere tener 24 o más años al momento de iniciar el ciclo académico.',
              tag: ''
            }
          ],
          applySince: null,
          periodId: null,
          periodDesc: null,
          program: null,
          weightedAverage: null,
          hasDebts: null,
          modalityList: null,
          currentAcademicData: {
            program: {
              id: null,
              name: null
            },
            campus: {
              id: null,
              name: null
            },
            modality: {
              id: null,
              name: null
            },
            studiesOption: {
              careerName: 'Ingeniería de Sistemas e Informática',
              modalityName: null,
              careerCode: 'PPSIS',
              modalityCode: 'Modalidad 100% Virtuals'
            }
          }
        }
      };
    }
    if (procedureId === 1033) {
      return {
        id: 1033,
        name: 'Reincorporación',
        amount: 'Sin costo',
        duration: 'Hasta 7 días hábiles',
        endDate: '29 jun 2023',
        detail: {
          periodApplied: [
            { id: '2233', name: 'Periodo Agosto 2023' }
            // { id: '2233', name: 'Periodo Prueba 2023' }
          ],
          currentAcademicData: {
            program: {
              id: 'PPSIS',
              name: 'ING. DE SISTEMAS E INFORMÁTICA'
            },
            campus: {
              id: 'LIMAS',
              name: 'LIMA SUR UTP'
            },
            modality: {
              id: 'PPE',
              name: 'Programa CGT'
            }
          }
        },
        error: null,
        // error: {
        //   title: 'No puedes realizar este tramite',
        //   description:
        //     'Para cambiar de modalidad debes realizar el trámite de reincorporación.'
        // },
        currentRequestId: 0,
        // currentRequestId: 99991,
        disabled: false,
        steps: [
          { name: 'Ciclo para reincorporarse', order: 1 },
          { name: 'Opciones de cambio', order: 2 },
          { name: 'Realizar pago', order: 3 },
          { name: 'Estado de solicitud', order: 4 }
        ]
      };
    }
    if (procedureId === 1032) {
      return {
        id: 1032,
        amount: '27',
        duration: 'Inmediato',
        name: 'Certificado de estudios',
        steps: [
          { id: 3, name: 'Registrar solicitud', order: 1 },
          { id: 4, name: 'Realiza el pago', order: 2 },
          { id: 5, name: 'Estado de solicitud', order: 3 }
        ],
        model: 'Certificado_estudio.pdf',
        requirements: null,
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        pin2: null,
        moreInfo: null,
        currentRequestId: 0,
        isValidatedStudentFoto: null,
        requestInProgress: false,
        disabled: false,
        endDate: null,
        text1: null,
        enrollment: null,
        requestLimit: null,
        enrolledCourses: null,
        stepsToFollow: [
          'Visualiza la información que saldrá en tu certificado antes de solicitarlo.',
          'Realiza el pago en nuestras opciones disponibles.',
          'Espera para la descarga de tu certificado.'
        ],
        deliverySchedule: null,
        hasPhoto: true,
        isProvince: null,
        isEntering: null,
        isReincorporated: null,
        isprocessFinished: null,
        districts: null,
        reasons: null,
        periods: [
          { id: '2191', description: 'Verano 2019' },
          { id: '2192', description: '2019 - Ciclo 1 Marzo' },
          { id: '2193', description: '2019 - Ciclo 2 Agosto' },
          { id: '2201', description: 'Verano 2020' },
          { id: '2202', description: '2020- Ciclo 1 Marzo' },
          { id: '2203', description: '2020 - Ciclo 2 Agosto' },
          { id: '2211', description: 'Verano 2021' },
          { id: '2212', description: '2021 - Ciclo 1 Marzo' },
          { id: '2213', description: '2021 - Ciclo 2 Agosto' },
          { id: '2221', description: 'Verano 2022' },
          { id: '2222', description: '2022 - Ciclo 1 Marzo' },
          { id: '2223', description: '2022 - Ciclo 2 Agosto' },
          { id: '2231', description: 'Verano 2023' }
        ],
        error: null,
        // error: {
        //   title: 'No tienes un ciclo concluido',
        //   description:
        //     'Para poder solicitar este trámite, mínimo tienes que tener un ciclo finalizado.'
        // },
        detail: {
          enrolledCourses: null,
          hasScholarship: false,
          datesModule: null,
          relatedCourses: null,
          periodApplied: null,
          studiesOptionList: null,
          campusApplied: null,
          applySince: null,
          periodId: null,
          periodDesc: null,
          program: null,
          weightedAverage: null,
          hasDebts: null,
          modalityList: null,
          currentAcademicData: {
            program: { id: null, name: null },
            campus: { id: null, name: null },
            modality: { id: null, name: null },
            grouping: { id: null, name: null },
            studiesOption: {
              careerName: null,
              modalityName: null,
              careerCode: null,
              modalityCode: null
            }
          }
        }
      };
    }
    if (procedureId === 1038) {
      return {
        id: 1032,
        amount: '27',
        duration: 'Inmediato',
        name: 'Carta de presentación',
        steps: [
          { id: 1, name: 'Registrar solicitud', order: 1 },
          { id: 2, name: 'Estado de solicitud', order: 2 }
        ],
        model: 'Certificado_estudio.pdf',
        requirements: null,
        pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
        pin2: null,
        moreInfo: null,
        currentRequestId: 0,
        isValidatedStudentFoto: null,
        requestInProgress: false,
        disabled: false,
        endDate: null,
        text1: null,
        enrollment: null,
        requestLimit: null,
        enrolledCourses: null,
        stepsToFollow: [
          'Visualiza la información que saldrá en tu certificado antes de solicitarlo.',
          'Realiza el pago en nuestras opciones disponibles.',
          'Espera para la descarga de tu certificado.'
        ],
        deliverySchedule: null,
        hasPhoto: true,
        isProvince: null,
        isEntering: null,
        isReincorporated: null,
        isprocessFinished: null,
        districts: null,
        reasons: null,
        periods: [
          { id: '2191', description: 'Verano 2019' },
          { id: '2192', description: '2019 - Ciclo 1 Marzo' },
          { id: '2193', description: '2019 - Ciclo 2 Agosto' },
          { id: '2201', description: 'Verano 2020' },
          { id: '2202', description: '2020- Ciclo 1 Marzo' },
          { id: '2203', description: '2020 - Ciclo 2 Agosto' },
          { id: '2211', description: 'Verano 2021' },
          { id: '2212', description: '2021 - Ciclo 1 Marzo' },
          { id: '2213', description: '2021 - Ciclo 2 Agosto' },
          { id: '2221', description: 'Verano 2022' },
          { id: '2222', description: '2022 - Ciclo 1 Marzo' },
          { id: '2223', description: '2022 - Ciclo 2 Agosto' },
          { id: '2231', description: 'Verano 2023' }
        ],
        // error: null,
        error: null,
        detail: {
          employabilityCharters: [
            { id: 'Cod1', description: 'prácticas', studentType: 'MATR' },
            { id: 'Cod2', description: 'internado', studentType: 'MATR' },
            { id: 'Cod3', description: 'empleo', studentType: 'MATR' }
          ],
          enrolledCourses: null,
          hasScholarship: false,
          datesModule: null,
          relatedCourses: null,
          periodApplied: null,
          studiesOptionList: null,
          campusApplied: null,
          applySince: null,
          periodId: null,
          periodDesc: null,
          program: null,
          weightedAverage: null,
          hasDebts: null,
          modalityList: null,
          currentAcademicData: {
            program: { id: null, name: null },
            campus: { id: null, name: null },
            modality: { id: null, name: null },
            grouping: { id: null, name: null },
            studiesOption: {
              careerName: null,
              modalityName: null,
              careerCode: null,
              modalityCode: null
            }
          }
        }
      };
    }
    return null;
  }

  async getProcedureRequestDetail(procedureId: number, requestId: number) {
    if (requestId === 1000) {
      return {
        procedure: {
          id: 1018,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de estudios',
          steps: [
            {
              id: 11,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: false,
              isCurrent: true,
              date: ''
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 1000,
          procedureId: 1018,
          name: 'Constancia de estudios',
          amount: '22',
          status: {
            status: 'CREADO',
            name: 'Pendiente',
            description: 'Activar pago'
          },
          duration: 'Inmediato',
          dateEnd: '15 Nov 2021',
          detail: {
            periodId: 2211,
            periodDesc: 'Verano 2021',
            program: null
          }
        }
      };
    }
    if (requestId === 1001) {
      return {
        procedure: {
          id: 1018,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de estudios',
          steps: [
            {
              id: 11,
              name: 'Selecciona el ciclo',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: false,
              isCurrent: true,
              date: ''
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 1001,
          procedureId: 1018,
          name: 'Constancia de estudios',
          amount: '22',
          status: {
            status: 'PAGO_ACTIVADO',
            name: 'Pendiente',
            description: 'Por pagar'
          },
          duration: 'Inmediato',
          dateEnd: '15 Nov 2021',
          detail: {
            periodId: 2211,
            periodDesc: 'Verano 2021',
            program: null
          }
        }
      };
    }
    if (requestId === 1002) {
      return {
        procedure: {
          id: 1018,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de estudios',
          steps: [
            {
              id: 11,
              name: 'Selecciona el ciclo',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '16 Nov 2021'
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: false,
              isCurrent: true,
              date: '17 Nov 2021'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 1002,
          procedureId: 1018,
          name: 'Constancia de estudios',
          amount: '22',
          status: {
            status: 'FINALIZADO',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: 'Inmediato',
          dateEnd: '15 Nov 2021',
          document:
            'Portal/Procedures/Certificados/de0be86b-541d-4a67-a1a4-c60afea2bc37.pdf',
          detail: {
            periodId: 2211,
            periodDesc: 'Verano 2021',
            program: null
          },
          expiredFile: false
        }
      };
    }
    if (requestId === 2001) {
      return {
        procedure: {
          id: 1021,
          amount: 'Sin costo',
          duration: '2 dias',
          name: 'Retiro de Periodo Lectivo',
          requirements: [],
          steps: [
            {
              id: 1,
              name: 'Registro de solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '25 Oct 2021'
            },
            {
              id: 2,
              name: 'Estado de solicitud',
              order: 2,
              isComplete: false,
              isCurrent: true,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 2001,
          procedureId,
          name: 'Retiro de Periodo Lectivo',
          amount: 'Sin costo',
          status: {
            status: 'PENDIENTE',
            name: 'Pendiente',
            description: 'Por atender en UTP'
          },
          duration: '10',
          dateEnd: '25 Dic 2021',
          text1:
            'De aplicar la solicitud de retiro de período, solo se realizará la reversión de las cuotas no vencidas.',
          comentary: ''
        }
      };
    }
    if (requestId === 2002) {
      return {
        procedure: {
          id: 1021,
          amount: 'Sin costo',
          duration: '2 dias',
          name: 'Retiro de Periodo Lectivo',
          requirements: [],
          steps: [
            {
              id: 1,
              name: 'Registro de solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '25 Oct 2021'
            },
            {
              id: 2,
              name: 'Estado de solicitud',
              order: 2,
              isComplete: true,
              isCurrent: true,
              date: '29 Oct 2021'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 2002,
          procedureId,
          name: 'Retiro de Periodo Lectivo',
          amount: 'Sin costo',
          status: {
            status: 'PROCEDE',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: '10',
          dateEnd: '25 Dic 2021',
          text1:
            'De aplicar la solicitud de retiro de período, solo se realizará la reversión de las cuotas no vencidas.',
          comentary:
            'De acuerdo a lo conversado, revisa en tu correo institucional los acuerdos y procedimiento de tu trámite.'
        }
      };
    }
    if (requestId === 2003) {
      return {
        procedure: {
          id: 1021,
          amount: 'Sin costo',
          duration: '2 dias',
          name: 'Retiro de Periodo Lectivo',
          requirements: [],
          steps: [
            {
              id: 1,
              name: 'Registro de solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '25 Oct 2021'
            },
            {
              id: 2,
              name: 'Estado de solicitud',
              order: 2,
              isComplete: true,
              isCurrent: true,
              date: '29 Oct 2021'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 2003,
          procedureId,
          name: 'Retiro de Periodo Lectivo',
          amount: 'Sin costo',
          status: {
            status: 'NO_PROCEDE',
            name: 'Finalizado',
            description: 'No procede'
          },
          duration: '10',
          dateEnd: '25 Dic 2021',
          text1:
            'De aplicar la solicitud de retiro de período, solo se realizará la reversión de las cuotas no vencidas.',
          comentary: '(Texto del asesor, personalizado) máximo 152 caracteres.'
        }
      };
    }
    if (requestId === 3001) {
      return {
        procedure: {
          id: 1019,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de ingreso',
          steps: [
            {
              id: 11,
              name: 'Selecciona el ciclo',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: false,
              isCurrent: true,
              date: ''
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 3001,
          procedureId: 1019,
          name: 'Constancia de ingreso',
          amount: '22',
          status: {
            status: 'CREADO',
            name: 'Pendiente',
            description: 'Activar pago'
          },
          duration: 'Inmediato',
          dateEnd: '15 Nov 2021',
          detail: {
            periodId: 2211,
            periodDesc: 'Verano 2021',
            program: 'Ingeniería Industrial'
          }
        }
      };
    }
    if (requestId === 3002) {
      return {
        procedure: {
          id: 1019,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de ingreso',
          steps: [
            {
              id: 11,
              name: 'Selecciona el ciclo',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: false,
              isCurrent: true,
              date: ''
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 3002,
          procedureId: 1019,
          name: 'Constancia de ingreso',
          amount: '22',
          status: {
            status: 'PAGO_ACTIVADO',
            name: 'Pendiente',
            description: 'Por pagar'
          },
          duration: 'Inmediato',
          dateEnd: '15 Nov 2021',
          detail: {
            periodId: 2211,
            periodDesc: 'Verano 2021',
            program: 'Ingeniería Industrial'
          }
        }
      };
    }
    if (requestId === 3003) {
      return {
        procedure: {
          id: 1019,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de ingreso',
          steps: [
            {
              id: 11,
              name: 'Selecciona el ciclo',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '17 Nov 2021'
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '18 Nov 2021'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 3003,
          procedureId: 1019,
          name: 'Constancia de ingreso',
          amount: '22',
          status: {
            status: 'FINALIZADO',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: 'Inmediato',
          dateEnd: '15 Nov 2021',
          detail: {
            periodId: 2211,
            periodDesc: 'Verano 2021',
            program: 'Ingeniería Industrial'
          }
        }
      };
    }
    if (requestId === 3004) {
      return {
        procedure: {
          id: 1024,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de Promedio Ponderado Acumulado',
          steps: [
            {
              id: 11,
              name: 'Selecciona el ciclo',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '17 Nov 2021'
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '18 Nov 2021'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.'
        },
        request: {
          id: 3004,
          procedureId: 1024,
          name: 'Constancia de Promedio Ponderado',
          amount: '22',
          status: {
            status: 'FINALIZADO',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: 'Inmediato',
          detail: {
            periodId: 2212,
            periodDesc: 'Verano 2021',
            program: 'Ingeniería Industrial'
          }
        }
      };
    }
    if (requestId === 4001) {
      return {
        procedure: {
          id: 1026,
          amount: '165',
          duration: 'Inmediato',
          name: 'Cambio de carrera, campus o modalidad',
          steps: [
            {
              id: 11,
              name: 'Selecciona el ciclo',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '17 Nov 2021'
            },
            {
              id: 13,
              name: 'Descargar constancia',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '18 Nov 2021'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
          link: 'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <b>utp.edu.pe/</b>'
        },
        request: {
          id: 4001,
          procedureId: 1026,
          name: 'Cambio de carrera, campus o modalidad',
          expiredFile: false,
          amount: '165',
          status: {
            status: 'FINALIZADO',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: 'Inmediato',
          detail: {
            periodId: 2212,
            periodDesc: 'Verano 2021',
            program: 'Ingeniería Industrial'
          }
        }
      };
    }
    if (requestId === 10) {
      return {
        procedure: {
          id: 1026,
          amount: '65',
          duration: '7 días hábiles',
          name: 'Cambio de carrera, campus o modalidad',
          requirements: [
            'Estar al día con las cuotas de pago.',
            'No debes estar suspendido por sanción disciplinaria.',
            'Encontrarte matriculado en el presente período académico.'
          ],
          steps: [
            {
              id: 8,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '24 Ene 2022'
            },
            {
              id: 9,
              name: 'Realizar pago',
              order: 2,
              isComplete: true,
              isCurrent: true,
              date: '24 Ene 2022'
            },
            {
              id: 10,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
          moreInfo:
            'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <a target="_blank" href="utp.edu.pe/">utp.edu.pe/</a>',
          endDate: '25 Feb 2022',
          text1: null,
          detail: {
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            currentAcademicData: {
              program: {
                id: 'PSIS',
                name: 'Ingenieria de sistemas'
              },
              campus: {
                id: 'LIMAN',
                name: 'LIMA NORTE'
              },
              modality: {
                id: 'PREG',
                name: 'PRE GRADO'
              }
            },
            newAcademicData: {
              program: {
                id: 'PEMPR',
                name: 'ADM. DE EMPRESAS'
              },
              campus: {
                id: 'CHICL',
                name: 'CAMPUS CHICLAYO'
              },
              modality: {
                id: '',
                name: ''
              }
            }
          }
        },
        request: {
          id: 10,
          procedureId: 1026,
          name: 'Cambio de carrera, campus o modalidad',
          amount: '165',
          status: {
            status: 'CREADO',
            name: 'Pendiente',
            description: 'Activar pago'
          },
          duration: '7 días hábiles',
          comentary: null,
          document: null
        }
      };
    }
    if (requestId === 11) {
      return {
        procedure: {
          id: 1026,
          amount: '165',
          duration: '7 días hábiles',
          name: 'Cambio de carrera, campus o modalidad',
          requirements: [
            'Estar al día con las cuotas de pago.',
            'No debes estar suspendido por sanción disciplinaria.',
            'Encontrarte matriculado en el presente período académico.'
          ],
          steps: [
            {
              id: 8,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '24 Ene 2022'
            },
            {
              id: 9,
              name: 'Realizar pago',
              order: 2,
              isComplete: true,
              isCurrent: true,
              date: '24 Ene 2022'
            },
            {
              id: 10,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
          moreInfo:
            'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <a target="_blank" href="utp.edu.pe/">utp.edu.pe/</a>',
          endDate: '25 Feb 2022',
          text1: null,
          detail: {
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            currentAcademicData: {
              program: {
                id: 'PSIS',
                name: 'Ingenieria de sistemas'
              },
              campus: {
                id: 'LIMAN',
                name: 'LIMA NORTE'
              },
              modality: {
                id: 'PREG',
                name: 'PRE GRADO'
              }
            },
            newAcademicData: {
              program: {
                id: 'PEMPR',
                name: 'ADM. DE EMPRESAS'
              },
              campus: {
                id: 'CHICL',
                name: 'CAMPUS CHICLAYO'
              },
              modality: {
                id: '',
                name: ''
              }
            }
          }
        },
        request: {
          id: 11,
          procedureId: 1026,
          name: 'Cambio de carrera, campus o modalidad',
          amount: '165',
          status: {
            status: 'PAGO_ACTIVADO',
            name: 'Pendiente',
            description: 'Por pagar'
          },
          duration: '7 días hábiles',
          comentary: null,
          document: null
        }
      };
    }
    if (requestId === 12) {
      return {
        procedure: {
          id: 1026,
          amount: '165',
          duration: '7 días hábiles',
          name: 'Cambio de carrera, campus o modalidad',
          requirements: [
            'Estar al día con las cuotas de pago.',
            'No debes estar suspendido por sanción disciplinaria.',
            'Encontrarte matriculado en el presente período académico.'
          ],
          steps: [
            {
              id: 8,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '24 Ene 2022'
            },
            {
              id: 9,
              name: 'Realizar pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '24 Ene 2022'
            },
            {
              id: 10,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: false,
              isCurrent: true,
              date: ''
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
          moreInfo:
            'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <a target="_blank" href="utp.edu.pe/">utp.edu.pe/</a>',
          endDate: '25 Feb 2022',
          text1: null,
          detail: {
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            currentAcademicData: {
              program: {
                id: 'PSIS',
                name: 'Ingenieria de sistemas'
              },
              campus: {
                id: 'LIMAN',
                name: 'LIMA NORTE'
              },
              modality: {
                id: 'PREG',
                name: 'PRE GRADO'
              }
            },
            newAcademicData: {
              program: {
                id: 'PEMPR',
                name: 'ADM. DE EMPRESAS'
              },
              campus: {
                id: 'CHICL',
                name: 'CAMPUS CHICLAYO'
              },
              modality: {
                id: '',
                name: ''
              }
            }
          }
        },
        request: {
          id: 12,
          procedureId: 1026,
          name: 'Cambio de carrera, campus o modalidad',
          amount: '165',
          status: {
            status: 'PAGO_REALIZADO',
            name: 'Pendiente',
            description: 'Por atender en UTP'
          },
          duration: '7 días hábiles',
          comentary: null,
          document: null
        }
      };
    }
    if (requestId === 13) {
      return {
        procedure: {
          id: 1026,
          amount: '75',
          duration: '7 días hábiles',
          name: 'Cambio de carrera, campus o modalidad',
          requirements: [
            'Estar al día con las cuotas de pago.',
            'No debes estar suspendido por sanción disciplinaria.',
            'Encontrarte matriculado en el presente período académico.'
          ],
          steps: [
            {
              id: 8,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '24 Ene 2022'
            },
            {
              id: 9,
              name: 'Realizar pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '25 Ene 2022'
            },
            {
              id: 10,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '26 Ene 2022'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
          moreInfo:
            'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <a target="_blank" href="utp.edu.pe/">utp.edu.pe/</a>',
          endDate: '25 Feb 2022',
          text1: null,
          detail: {
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            currentAcademicData: {
              program: {
                id: 'PSIS',
                name: 'Ingenieria de sistemas'
              },
              campus: {
                id: 'LIMAN',
                name: 'LIMA NORTE'
              },
              modality: {
                id: 'PREG',
                name: 'PRE GRADO'
              }
            },
            newAcademicData: {
              program: {
                id: 'PEMPR',
                name: 'ADM. DE EMPRESAS'
              },
              campus: {
                id: 'CHICL',
                name: 'CAMPUS CHICLAYO'
              },
              modality: {
                id: '',
                name: ''
              }
            }
          }
        },
        request: {
          id: 13,
          procedureId: 1026,
          name: 'Cambio de carrera, campus o modalidad',
          amount: '165',
          status: {
            status: 'PROCEDE',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: '7 días hábiles',
          comentary: null,
          document: null
        }
      };
    }
    if (requestId === 14) {
      return {
        procedure: {
          id: 1026,
          amount: '165',
          duration: '7 días hábiles',
          name: 'Cambio de carrera, campus o modalidad',
          requirements: [
            'Estar al día con las cuotas de pago.',
            'No debes estar suspendido por sanción disciplinaria.',
            'Encontrarte matriculado en el presente período académico.'
          ],
          steps: [
            {
              id: 8,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '24 Ene 2022'
            },
            {
              id: 9,
              name: 'Realizar pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '25 Ene 2022'
            },
            {
              id: 10,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '26 Ene 2022'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
          moreInfo:
            'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <a target="_blank" href="utp.edu.pe/">utp.edu.pe/</a>',
          endDate: '25 Feb 2022',
          text1: null,
          detail: {
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            currentAcademicData: {
              program: {
                id: 'PSIS',
                name: 'Ingenieria de sistemas'
              },
              campus: {
                id: 'LIMAN',
                name: 'LIMA NORTE'
              },
              modality: {
                id: 'PREG',
                name: 'PRE GRADO'
              }
            },
            newAcademicData: {
              program: {
                id: 'PEMPR',
                name: 'ADM. DE EMPRESAS'
              },
              campus: {
                id: 'CHICL',
                name: 'CAMPUS CHICLAYO'
              },
              modality: {
                id: '',
                name: ''
              }
            }
          }
        },
        request: {
          id: 14,
          procedureId: 1026,
          name: 'Cambio de carrera, campus o modalidad',
          amount: '165',
          status: {
            status: 'NO_PROCEDE',
            name: 'Finalizado',
            description: 'No procede'
          },
          duration: '7 días hábiles',
          comentary: '(Texto del asesor, personalizado) máximo 152 caracteres.',
          document: null
        }
      };
    }
    if (requestId === 15) {
      return {
        procedure: {
          id: 1027,
          amount: '22',
          duration: 'Inmediato',
          name: 'Constancia de adeudo / no adeudo',
          steps: [
            {
              id: 11,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '15 Nov 2021'
            },
            {
              id: 12,
              name: 'Realiza el pago',
              order: 2,
              isComplete: false,
              isCurrent: true,
              date: '16 Nov 2021'
            },
            {
              id: 13,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: '17 Nov 2021'
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          detail: {
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            hasDebts: true,
            currentAcademicData: {
              program: {
                id: 'PSIS',
                name: 'Ingenieria de sistemas'
              },
              campus: {
                id: 'LIMAN',
                name: 'LIMA NORTE'
              },
              modality: {
                id: 'PREG',
                name: 'PRE GRADO'
              }
            },
            newAcademicData: {
              program: {
                id: 'PEMPR',
                name: 'ADM. DE EMPRESAS'
              },
              campus: {
                id: 'CHICL',
                name: 'CAMPUS CHICLAYO'
              },
              modality: {
                id: '',
                name: ''
              }
            }
          }
        },
        request: {
          id: 15,
          procedureId: 1027,
          name: 'Constancia de estudios',
          amount: '22',
          status: {
            status: 'CREADO',
            name: 'Pendiente',
            description: 'Activar pago'
          },
          duration: 'Inmediato',
          dateEnd: '15 Nov 2021',
          detail: {
            periodId: 2211,
            periodDesc: 'Verano 2021',
            program: null
          }
        }
      };
    }
    if (Number(requestId) === 16) {
      return {
        procedure: {
          id: 1030,
          amount: '65',
          duration: '7 días hábiles',
          name: 'Emisión de carné universitario',
          requirements: [
            'Estar al día con las cuotas de pago.',
            'No debes estar suspendido por sanción disciplinaria.',
            'Encontrarte matriculado en el presente período académico.'
          ],
          steps: [
            {
              id: 1,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false
            },
            {
              id: 2,
              name: 'Realiza el pago',
              order: 2,
              isComplete: false,
              isCurrent: true
            },
            {
              id: 3,
              name: 'Estado de solicitud',
              order: 3
            }
          ],
          pin1: 'Te notificaremos a tu <b>correo institucional</b> cuando tu solicitud haya finalizado.',
          pin2: 'Cambio de modalidad y cambio de campus, está sujeto a la adaptación de tarifas y pensiones del campus de destino.',
          moreInfo:
            'Para más información de las modalidades, carreras y nuestros campus, ingresa aquí: <a target="_blank" href="utp.edu.pe/">utp.edu.pe/</a>',
          endDate: '25 Feb 2022',
          text1: null,
          detail: {
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            currentAcademicData: {
              program: {
                id: 'PSIS',
                name: 'Ingenieria de sistemas'
              },
              campus: {
                id: 'LIMAN',
                name: 'LIMA NORTE'
              },
              modality: {
                id: 'PREG',
                name: 'PRE GRADO'
              }
            },
            newAcademicData: {
              program: {
                id: 'PEMPR',
                name: 'ADM. DE EMPRESAS'
              },
              campus: {
                id: 'CHICL',
                name: 'CAMPUS CHICLAYO'
              },
              modality: {
                id: '',
                name: ''
              }
            }
          }
        },
        request: {
          id: 16,
          procedureId: 1030,
          name: 'Cambio de carrera, campus o modalidad',
          amount: '165',
          status: {
            status: 'CREADO',
            name: 'Pendiente',
            description: 'Activar pago'
          },
          duration: '7 días hábiles',
          comentary: null,
          document: null
        }
      };
    }
    if (requestId === 124787) {
      return {
        procedure: {
          id: 1031,
          amount: 'Sin costo',
          duration: 'Inmediato',
          name: 'Cambio de opción de estudio - Modalidad',
          requirements: null,
          steps: [
            {
              id: 6,
              name: 'Registro de solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '03 Feb 2023'
            },
            {
              id: 7,
              name: 'Estado de solicitud',
              order: 2,
              isComplete: true,
              isCurrent: true,
              date: '03 Feb 2023'
            }
          ],
          stepsToFollow: null,
          pin1: null,
          pin2: null,
          moreInfo: null,
          endDate: null,
          text1: null,
          detail: {
            applySince: '2023 - Ciclo 1 Marzo',
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            hasDebts: null,
            deliveryMode: null,
            district: null,
            currentAcademicData: {
              program: {
                id: null,
                name: null
              },
              campus: {
                id: null,
                name: null
              },
              modality: {
                id: null,
                name: null
              },
              studiesOption: {
                careerName:
                  'Ingeniería de Sistemas e Informática - Modalidad Semipresencial CGT',
                careerCode: 'PPSIS',
                modalityName: null,
                modalityCode: null
              }
            },
            newAcademicData: {
              program: {
                id: null,
                name: null
              },
              campus: {
                id: null,
                name: null
              },
              modality: {
                id: null,
                name: null
              },
              studiesOption: {
                careerName:
                  'Cambiar a Ingeniería De Sistemas E Informática - Modalidad Semipresencial – 50% Virtual. Los créditos aprobados en modalidad virtual, a lo largo de la carrera, son 50%. Los cursos tienen una duración de 18 semanas.',
                careerCode: 'PSI50',
                modalityName: null,
                modalityCode: null
              }
            }
          }
        },
        request: {
          id: 124787,
          procedureId: 1031,
          name: 'Cambio de opción de estudio - Modalidad',
          amount: 'Sin costo',
          status: {
            status: 'PROCEDE',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: 'Inmediato',
          comentary: null,
          document: null,
          expiredFile: false
        }
      };
    }
    if (requestId === 99991) {
      // after reincorporation - FINALIZADO_PROCEDE
      return {
        procedure: {
          id: 1033,
          name: 'Reincorporación',
          amount: 'Sin costo',
          duration: '7 días hábiles',
          endDate: '29 jun 2023',
          requirements: null,
          steps: [
            {
              id: 1,
              name: 'Ciclo para reincorporarse',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '03 Feb 2023'
            },
            { id: 2, name: 'Opciones de cambio', order: 2 },
            { id: 3, name: 'Realizar pago', order: 3 },
            { id: 4, name: 'Estado de solicitud', order: 4 }
          ],
          stepsToFollow: null,
          pin1: null,
          pin2: null,
          moreInfo: null,
          text1: null,
          detail: {
            applySince: '2023 - Ciclo 1 Marzo',
            periodId: null,
            periodDesc: null,
            program: null,
            weightedAverage: null,
            hasDebts: null,
            deliveryMode: null,
            district: null,
            currentAcademicData: {
              program: {
                id: null,
                name: null
              },
              campus: {
                id: null,
                name: null
              },
              modality: {
                id: null,
                name: null
              },
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null
              }
            }
            // newAcademicData: {
            //   program: {
            //     id: 'PCONT',
            //     name: 'Contabilidad'
            //   },
            //   campus: {
            //     id: 'LIMAN',
            //     name: 'Lima Norte'
            //   },
            //   modality: {
            //     id: 'PCONT50',
            //     name: 'Nueva modalidad'
            //   },
            //   studiesOption: {
            //     careerName: null,
            //     careerCode: null,
            //     modalityName: null,
            //     modalityCode: null
            //   }
            // }
          }
        },
        request: {
          id: 99991,
          procedureId: 1033,
          name: 'Reincorporación',
          amount: 'Sin costo',
          status: {
            status: 'FINALIZADO',
            name: 'Finalizado',
            description: 'Procede'
          },
          duration: 'Inmediato',
          comentary: null,
          document: null,
          expiredFile: false
        }
      };
    }
    if (requestId === 5000) {
      return {
        procedure: {
          id: 1036,
          amount: '117',
          duration: 'Inmediato',
          name: 'Retiro de Curso',
          requirements: null,
          steps: [
            {
              id: 33,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: false,
              isCurrent: true,
              date: '',
              __typename: 'ProcedureStep'
            },
            {
              id: 34,
              name: 'Realizar pago',
              order: 2,
              isComplete: false,
              isCurrent: false,
              date: '',
              __typename: 'ProcedureStep'
            },
            {
              id: 35,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: '',
              __typename: 'ProcedureStep'
            }
          ],
          stepsToFollow: null,
          pin1: null,
          pin2: null,
          moreInfo: null,
          endDate: '31 Mar 2024',
          text1: null,
          detail: {
            course: null,
            test: null,
            destinationCampus: null,
            applySince: '',
            periodId: null,
            periodDesc: null,
            program: null,
            campus: null,
            contacto: null,
            weightedAverage: null,
            hasDebts: null,
            deliveryMode: null,
            district: null,
            enrolledCourses: [
              {
                id: '100000N01I',
                name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I',
                classId: '4244',
                courseId: '013776',
                __typename: 'CourseWithdrawal'
              }
            ],
            currentAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            newAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              shift: null,
              shiftDesc: null,
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            __typename: 'ProcedureDetail'
          },
          __typename: 'Procedure'
        },
        request: {
          id: 5000,
          procedureId: 1036,
          name: 'Retiro de Curso',
          amount: '117',
          requiresPayment: null,
          payed: false,
          status: {
            status: 'CREADO',
            name: 'Pendiente',
            description: 'Activar pago',
            __typename: 'ProcedureStatus'
          },
          duration: 'Inmediato',
          comentary: null,
          document: null,
          expiredFile: false,
          statusBse: null,
          __typename: 'ProcedureRequest'
        },
        __typename: 'ProcedureRequestDetail'
      };
    }
    if (requestId === 5001) {
      return {
        procedure: {
          id: 1036,
          amount: '117',
          duration: 'Inmediato',
          name: 'Retiro de Curso',
          requirements: null,
          steps: [
            {
              id: 33,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: false,
              isCurrent: true,
              date: '',
              __typename: 'ProcedureStep'
            },
            {
              id: 34,
              name: 'Realizar pago',
              order: 2,
              isComplete: false,
              isCurrent: false,
              date: '',
              __typename: 'ProcedureStep'
            },
            {
              id: 35,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: false,
              isCurrent: false,
              date: '',
              __typename: 'ProcedureStep'
            }
          ],
          stepsToFollow: null,
          pin1: null,
          pin2: null,
          moreInfo: null,
          endDate: '31 Mar 2024',
          text1: null,
          detail: {
            course: null,
            test: null,
            destinationCampus: null,
            applySince: '',
            periodId: null,
            periodDesc: null,
            program: null,
            campus: null,
            contacto: null,
            weightedAverage: null,
            hasDebts: null,
            deliveryMode: null,
            district: null,
            enrolledCourses: [
              {
                id: '100000N01I',
                name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I',
                classId: '4244',
                courseId: '013776',
                __typename: 'CourseWithdrawal'
              }
            ],
            currentAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            newAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              shift: null,
              shiftDesc: null,
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            __typename: 'ProcedureDetail'
          },
          __typename: 'Procedure'
        },
        request: {
          id: 5001,
          procedureId: 1036,
          name: 'Retiro de Curso',
          amount: '117',
          requiresPayment: null,
          payed: false,
          status: {
            status: 'PAGO_ACTIVADO',
            name: 'Pago activado',
            description: 'Pago activado',
            __typename: 'ProcedureStatus'
          },
          duration: 'Inmediato',
          comentary: null,
          document: null,
          expiredFile: false,
          statusBse: null,
          __typename: 'ProcedureRequest'
        },
        __typename: 'ProcedureRequestDetail'
      };
    }
    if (requestId === 5005) {
      return {
        procedure: {
          id: 1036,
          amount: '117',
          duration: 'Inmediato',
          name: 'Retiro de Curso',
          requirements: null,
          steps: [
            {
              id: 33,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '',
              __typename: 'ProcedureStep'
            },
            {
              id: 34,
              name: 'Realizar pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '10 mar 2024',
              __typename: 'ProcedureStep'
            },
            {
              id: 35,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '13 mar 2024',
              __typename: 'ProcedureStep'
            }
          ],
          stepsToFollow: null,
          pin1: null,
          pin2: null,
          moreInfo: null,
          endDate: '31 Mar 2024',
          text1: null,
          detail: {
            course: null,
            test: null,
            destinationCampus: null,
            applySince: '',
            periodId: null,
            periodDesc: null,
            program: null,
            campus: null,
            contacto: null,
            weightedAverage: null,
            hasDebts: null,
            deliveryMode: null,
            district: null,
            enrolledCourses: [
              {
                id: '100000N01I',
                name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I',
                classId: '4244',
                courseId: '013776',
                __typename: 'CourseWithdrawal'
              }
            ],
            currentAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            newAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              shift: null,
              shiftDesc: null,
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            __typename: 'ProcedureDetail'
          },
          __typename: 'Procedure'
        },
        request: {
          id: 5005,
          procedureId: 1036,
          name: 'Retiro de Curso',
          amount: '117',
          requiresPayment: null,
          payed: false,
          status: {
            status: 'PROCEDE',
            name: 'Procede',
            description: 'Procede',
            __typename: 'ProcedureStatus'
          },
          duration: 'Inmediato',
          comentary: null,
          document: null,
          expiredFile: false,
          statusBse: null,
          __typename: 'ProcedureRequest'
        },
        __typename: 'ProcedureRequestDetail'
      };
    }
    if (requestId === 15000) {
      return {
        procedure: {
          id: 1032,
          amount: '117',
          duration: 'Inmediato',
          name: 'Retiro de Curso',
          requirements: null,
          steps: [
            {
              id: 33,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '',
              __typename: 'ProcedureStep'
            },
            {
              id: 34,
              name: 'Realizar pago',
              order: 2,
              isComplete: true,
              isCurrent: false,
              date: '10 mar 2024',
              __typename: 'ProcedureStep'
            },
            {
              id: 35,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '13 mar 2024',
              __typename: 'ProcedureStep'
            }
          ],
          stepsToFollow: null,
          pin1: null,
          pin2: null,
          moreInfo: null,
          endDate: '31 Mar 2024',
          text1: null,
          detail: {
            course: null,
            test: null,
            destinationCampus: null,
            applySince: '',
            periodId: null,
            periodDesc: null,
            program: null,
            campus: null,
            contacto: null,
            weightedAverage: null,
            hasDebts: null,
            deliveryMode: null,
            district: null,
            enrolledCourses: [
              {
                id: '100000N01I',
                name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I',
                classId: '4244',
                courseId: '013776',
                __typename: 'CourseWithdrawal'
              }
            ],
            currentAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            newAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              shift: null,
              shiftDesc: null,
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            __typename: 'ProcedureDetail'
          },
          __typename: 'Procedure'
        },
        request: {
          id: 5005,
          procedureId: 1036,
          name: 'Retiro de Curso',
          amount: '117',
          requiresPayment: null,
          payed: false,
          status: {
            status: 'PROCEDE',
            name: 'Procede',
            description: 'Procede',
            __typename: 'ProcedureStatus'
          },
          duration: 'Inmediato',
          comentary: null,
          document: null,
          expiredFile: false,
          statusBse: null,
          __typename: 'ProcedureRequest'
        },
        __typename: 'ProcedureRequestDetail'
      };
    }
    if (requestId === 1601) {
      return {
        procedure: {
          id: 1038,
          amount: '117',
          duration: 'Inmediato',
          name: 'Carta empleabilidad',
          requirements: null,
          steps: [
            {
              id: 33,
              name: 'Registrar solicitud',
              order: 1,
              isComplete: true,
              isCurrent: false,
              date: '',
              __typename: 'ProcedureStep'
            },
            {
              id: 35,
              name: 'Estado de solicitud',
              order: 3,
              isComplete: true,
              isCurrent: true,
              date: '13 mar 2024',
              __typename: 'ProcedureStep'
            }
          ],
          stepsToFollow: null,
          pin1: null,
          pin2: null,
          moreInfo: null,
          endDate: '31 Mar 2024',
          text1: null,
          detail: {
            course: null,
            test: null,
            destinationCampus: null,
            applySince: '',
            periodId: null,
            periodDesc: null,
            program: null,
            campus: null,
            contacto: null,
            weightedAverage: null,
            hasDebts: null,
            deliveryMode: null,
            district: null,
            enrolledCourses: [
              {
                id: '100000N01I',
                name: 'COMPRENSIÓN Y REDACCIÓN DE TEXTOS I',
                classId: '4244',
                courseId: '013776',
                __typename: 'CourseWithdrawal'
              }
            ],
            currentAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            newAcademicData: {
              program: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              campus: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              modality: {
                id: null,
                name: null,
                __typename: 'Item'
              },
              shift: null,
              shiftDesc: null,
              studiesOption: {
                careerName: null,
                careerCode: null,
                modalityName: null,
                modalityCode: null,
                __typename: 'StudiesOption'
              },
              __typename: 'AcademicData'
            },
            employabilityCharterDetail: {
              charterDesc: 'charterDesc',
              companyName: 'companyName',
              representative: 'representative',
              position: 'position',
              duration: 'duration',
              documentPath: 'documentPath'
            },
            __typename: 'ProcedureDetail'
          },
          __typename: 'Procedure'
        },
        request: {
          id: 5005,
          procedureId: 1036,
          name: 'Retiro de Curso',
          amount: '117',
          requiresPayment: null,
          payed: false,
          status: {
            status: 'NO_PROCEDE',
            name: 'No procede',
            description: 'Procede',
            __typename: 'ProcedureStatus'
          },
          duration: 'Inmediato',
          comentary: null,
          document: null,
          expiredFile: false,
          statusBse: null,
          __typename: 'ProcedureRequest'
        },
        __typename: 'ProcedureRequestDetail'
      };
    }
    const data = {};
    return data;
  }

  async getStudentInformation() {
    const data = {
      student: {
        procedureInfo: {
          firstName: 'Roberto Armando',
          lastName: 'Cardozo Sanchez',
          code: 'U202112345',
          faculty: 'Medicina Humana'
        }
      }
    };
    return data;
  }

  async getProceduresCategory() {
    const data = [
      {
        isExternal: false,
        categoryId: 1,
        procedureId: 1018,
        name: 'Constancia de estudios',
        description: '',
        url: 'constancia-estudios',
        duration: 'Inmediato',
        price: '22.00',
        type: 1,
        category: 'CERTIFICADOS'
      },
      {
        isExternal: false,
        categoryId: 1,
        procedureId: 1019,
        name: 'Constancia de ingreso',
        description: '',
        url: 'constancia-ingreso',
        duration: '7 días hábiles',
        deadline: '',
        price: '0.00',
        category: 'CERTIFICADOS'
      },
      // {
      //   isExternal: false,
      //   categoryId: 2,
      //   procedureId: 1020,
      //   name: 'Registro / Actualización de fotografía',
      //   description: '',
      //   url: 'registro-actualizacion-fotografia',
      //   duration: '7 días hábiles',
      //   deadline: '',
      //   price: '0.00',
      //   category: 'SOLICITUDES'
      // },
      {
        isExternal: false,
        categoryId: 2,
        procedureId: 1021,
        name: 'Retiro de periodo lectivo',
        description: '',
        url: 'retiro-periodo-lectivo',
        duration: '1 día',
        price: '22.00',
        endDate: '25 Dic 2021',
        category: 'SOLICITUDES'
      },
      {
        isExternal: false,
        categoryId: 2,
        procedureId: 1026,
        name: 'Cambio de carrera, campus o modalidad',
        description: '',
        url: 'cambio-carrera-campus-modalidad',
        duration: '1 día',
        price: '22.00',
        endDate: '25 Dic 2021',
        category: 'SOLICITUDES'
      },
      // {
      //   isExternal: false,
      //   categoryId: 2,
      //   procedureId: 1030,
      //   name: 'Emisión de carné universitario',
      //   description: '',
      //   url: 'emision-carnet-universitario',
      //   duration: '1 día',
      //   price: '28.00',
      //   // endDate: '22 Dic 2022',
      //   category: 'SOLICITUDES'
      // },
      {
        isExternal: false,
        categoryId: 1,
        procedureId: 1024,
        name: 'Constancia de Promedio Ponderado Acumulado',
        description: '',
        url: 'constancia-promedio-ponderado-acumulado',
        duration: '1 día',
        price: '22.00',
        category: 'CERTIFICADOS'
      },
      {
        isExternal: false,
        categoryId: 1,
        procedureId: 1025,
        name: 'Constancia de Matricula',
        description: '',
        url: 'constancia-matricula',
        duration: '1 día',
        price: '22.00',
        category: 'CERTIFICADOS'
      },
      {
        isExternal: false,
        categoryId: 1,
        procedureId: 1027,
        name: 'Constancia de adeudo / no adeudo',
        description: '',
        url: 'constancia-adeudo-no-adeudo',
        duration: 'Inmediato',
        price: '22.00',
        category: 'CERTIFICADOS'
      },
      {
        isExternal: true,
        categoryId: 3,
        procedureId: 3001,
        name: 'Beca Socio Económica',
        description: '',
        url: 'beca-socio-economica',
        duration: '',
        price: '',
        category: 'BECAS'
      }
    ];
    return data;
  }

  async getCampusByModality(modalityId: string) {
    if (modalityId === 'PPE') {
      return [
        {
          id: 'LIMA',
          name: 'Campus Lima Centro'
        },
        {
          id: 'LIMAN',
          name: 'Campus Lima Norte'
        },
        {
          id: 'AREQU',
          name: 'Campus Arequipa'
        }
      ];
    }
    if (modalityId === 'PREG') {
      return [
        {
          id: 'LIMAS',
          name: 'Campus Lima Sur'
        },
        {
          id: 'LIMAE',
          name: 'Campus Lima Este'
        },
        {
          id: 'CHICL',
          name: 'Campus Chiclayo'
        }
      ];
    }
    const data = {};
    return data;
  }

  async getProgramByCampus(campusId: string) {
    if (campusId === 'LIMAS') {
      return [
        {
          id: 'PINGCV',
          name: 'Ingeniería Civil'
        },
        {
          id: 'PINGIND',
          name: 'Ingeniería Industrial'
        },
        {
          id: 'PINGMEC',
          name: 'Ingeniería Mecánica'
        },
        {
          id: 'PINGST',
          name: 'Ingeniería de Sistemas'
        },
        {
          id: 'PINGENV',
          name: 'Ingeniería Ambiental'
        },
        {
          id: 'PADMHTL',
          name: 'Administracion Hotelera'
        },
        {
          id: 'PADMNEG',
          name: 'Administracion de Negocios'
        },
        {
          id: 'PNEGINT',
          name: 'Negocios Internacionales'
        }
      ];
    }
    const data = [
      {
        id: 'PSIST',
        name: 'Ingeniería de Sistemas'
      },
      {
        id: 'PCONT',
        name: 'Contabilidad'
      },
      {
        id: 'PDER',
        name: 'Derecho'
      }
    ];
    return data;
  }

  async getProceduresNotAutomated() {
    return [
      {
        id: '621d2accb8322c6ed2a18619',
        name: 'Corina Castro'
      },
      {
        id: '621d2acc8996efe099060265',
        name: 'Baker Justice'
      },
      {
        id: '621d2acc15f9da3b85eb6f2c',
        name: 'Vasquez Frye'
      },
      {
        id: '621d2acc6a9483cd3e3da516',
        name: 'Ava Holman'
      },
      {
        id: '621d2acc1630aca994410604',
        name: 'Rogers Gentry'
      },
      {
        id: '621d2accdfa59d02d331979d',
        name: 'Simmons Powell'
      },
      {
        id: '621d2acc41d166f96560cf85',
        name: 'Earline Knowles'
      },
      {
        id: '621d2acc6077be2b57b0fd04',
        name: 'Sheryl Delgado'
      },
      {
        id: '621d2accdeebf613c3aa1825',
        name: 'Burt Koch'
      },
      {
        id: '621d2acc31cacb7f919be78f',
        name: 'Lucas Jensen'
      },
      {
        id: '621d2acc6ccbd4b19bf327a8',
        name: 'Harrison Dean'
      },
      {
        id: '621d2acc68cdaaf18e862d03',
        name: 'Emily Mckee'
      },
      {
        id: '621d2accc99b7b1906419fa5',
        name: 'Gabriela Villarreal'
      },
      {
        id: '621d2acc12bb59b742b9eed6',
        name: 'Nadine Haney'
      },
      {
        id: '621d2acca246d10160261a06',
        name: 'Castro Simpson'
      },
      {
        id: '621d2accb49ba54ea9901f83',
        name: 'Baird Mcleod'
      },
      {
        id: '621d2acca7f4da38b6f28f9b',
        name: 'Buck Mccormick'
      },
      {
        id: '621d2acceb935686d5846677',
        name: 'Jeri Vasquez'
      },
      {
        id: '621d2acc272922cfa95529ab',
        name: 'Geraldine Davis'
      },
      {
        id: '621d2acc9d1ab979c26b94a9',
        name: 'Kathie Lee'
      }
    ];
  }

  async registerTicketNotAutomated() {
    return {
      ticketId: '00231',
      days: 9
    };
  }

  async getProceduresCreated() {
    return [
      {
        procedureId: 1026,
        requestId: 10,
        type: 'certificado',
        name: 'PRUEBA DE REDIRECT A VER DETALLE',
        status: {
          status: 'NO_PROCEDE',
          name: 'No procede',
          description: 'Activar pago'
        },
        startDate: '22 feb 2022',
        endDate: '27 feb 2022'
      },
      {
        procedureId: 1017,
        requestId: 10,
        type: 'Solicitud',
        name: 'Rectificación de nota',
        status: {
          status: 'NO_PROCEDE',
          name: 'No registrado',
          description: 'No registrado'
        },
        startDate: '22 feb 2022',
        endDate: '27 feb 2022'
      },
      {
        procedureId: 1021,
        requestId: 102,
        type: 'solicitud',
        name: 'Constancia Constancia Constancia Constancia Constancia Constancia Constancia Constancia',
        status: {
          status: 'FINALIZADO',
          name: 'Finalizado',
          description: 'No procede'
        },
        startDate: '22 feb 2022',
        endDate: '27 feb 2022'
      },
      {
        procedureId: 1022,
        requestId: 103,
        type: 'ticket',
        name: 'Constancia de promedio ponderado acumulado',
        status: {
          status: 'PAGO_REALIZADO',
          name: 'Pendiente',
          description: 'Por atender UTP'
        },
        startDate: '22 feb 2022',
        endDate: ''
      },
      {
        procedureId: 1022,
        requestId: 103,
        type: 'ticket',
        name: 'Constancia de promedio ponderado acumulado, Constancia de promedio ponderado acumulado, Constancia de promedio ponderado acumulado',
        status: {
          status: 'PAGO_REALIZADO',
          name: 'Pendiente',
          description: 'Por atender UTP'
        },
        startDate: '22 feb 2022',
        endDate: ''
      },
      {
        procedureId: 1022,
        requestId: 103,
        type: 'ticket',
        name: 'Constancia de promedio ponderado acumulado, Constancia de promedio ponderado acumulado, Constancia de promedio ponderado acumulado',
        status: {
          status: 'PAGO_REALIZADO',
          name: 'Pendiente',
          description: 'Por atender UTP'
        },
        startDate: '22 feb 2022',
        endDate: ''
      },
      {
        procedureId: 1022,
        requestId: 103,
        type: 'ticket',
        name: 'Constancia de promedio ponderado acumulado, Constancia de promedio ponderado acumulado, Constancia de promedio ponderado acumulado',
        status: {
          status: 'PAGO_REALIZADO',
          name: 'Pendiente',
          description: 'Por atender UTP'
        },
        startDate: '22 feb 2022',
        endDate: ''
      }
    ];
  }

  async getYearsOfProcedures() {
    return [2022, 2021, 2020, 2019, 2018];
  }

  async registerChangePhoto() {
    const data = {
      error: null,
      requestId: 0
    };
    return data;
  }

  async getPeriodsWithDebts() {
    return ['2222', '2231', '2223', '2241', '2243'];
  }
}
